import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectIsPinned,
  sidebarActions,
} from 'redux/app/sidebar/sidebar.slice';

export const SIDEBAR_LEAVE_DELAY = 100;

export const useSidebarComponent = () => {
  const dispatch = useDispatch();
  const pinned = useSelector(selectIsPinned);
  const [hovered, setHovered] = useState(false);
  const leaveTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const expanded = pinned || hovered;

  const onMouseEnter = useCallback(() => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    setHovered(true);
  }, []);

  const onMouseLeave = useCallback(() => {
    leaveTimeoutRef.current = setTimeout(() => {
      setHovered(false);
    }, SIDEBAR_LEAVE_DELAY);
  }, []);

  const onTogglePin = useCallback(() => {
    dispatch(sidebarActions.togglePinned());
  }, [dispatch]);

  return {
    pinned,
    hovered,
    expanded,
    onMouseEnter,
    onMouseLeave,
    onTogglePin,
  };
};
